<div class="pageheader">
  <div class="page-title">
    <h1>Error Rules</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Transport_View_OutgoingLocation_Log'" [title]="'Error rules log'">
        <app-change-log-link-entity type="ErrorRule"></app-change-log-link-entity>
        <app-change-log-link-entity type="ErrorRuleCondition"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="btn-toolbar">

  @if (orderEditMode) {
    <div class="btn-group">
      <app-button primary width="100%" (buttonClick)="onSaveOrderClick()">Save Order</app-button>
    </div>
    <div class="btn-group">
      <app-button secondary width="100%" (buttonClick)="onCandelOrderEditClick()">Cancel</app-button>
    </div>
  }
  @else {
  <div class="btn-group">
    @if (allowAdding) {
      <app-button primary width="100%" (buttonClick)="onAddErrorRule(0)">New Error Rule</app-button>
    }
  </div>
  <div class="btn-group">
    @if (allowUpdating) {
      <app-button primary width="100%" (buttonClick)="onSetFallbackClick()">Edit Default Error Rule</app-button>
    }
  </div>
  <div class="btn-group">
    @if (allowUpdating) {
      <app-button primary width="100%" (buttonClick)="onEditOrderClick()">Edit List Order</app-button>
    }
  </div>
}

</div>

<dx-data-grid #errorrules biz-grid
  [selection]='{ mode: "none" }'
  [dataSource]='errorRules()'
  [showBorders]="true"
  [bizSetColumnChooser]="true"
  [bizSetAllowColumnReordering]="false"
  [bizSetGroupPanel]="false"
  [bizSetPager]="false"
  [bizSetHeaderFilter]="true"
  [bizSetSummary]="false"
  [bizHideSelectedRowsCompnent]="true"
  [allowColumnResizing]="true"
  keyExpr="Id"
  (bizOnToolbarPreparing)="onToolbarPreparing($event)"
  (onCellPrepared)="onCellPrepared($event)"
  (onRowPrepared)="onRowPrepared($event)"
  (onRowDblClick)="onRowDblClick($event)"
  >

  <dxo-editing [allowAdding]="allowAdding" [allowUpdating]="allowUpdating" [allowDeleting]="allowDeleting"></dxo-editing>

  <dxo-row-dragging
    [allowReordering]="orderEditMode"
    [onDragStart]="onDragStart"
    [onDragChange]="onDragChange"
    [onReorder]="onReorder"
    dropFeedbackMode="push">
  </dxo-row-dragging>

  <dxo-sorting mode="none"></dxo-sorting>

  <dxo-group-panel
    [visible]="true"
    [emptyPanelText]="allowUpdating ? 'Important: The order matters. Use the \'Edit list order\' function to reorder the list.' : ''">
  </dxo-group-panel>

  <dxi-column width="60" dataField="SortOrder" caption="Order" dataType="number" [allowGrouping]="false" [allowFiltering]="false" alignment="center" [calculateDisplayValue]="getSortOrderDisplay"></dxi-column>
  <dxi-column width="80" dataField="IsEnabled" caption="Is Enabled" dataType="boolean" [allowGrouping]="false" [allowFiltering]="false"></dxi-column>
  <dxi-column width="60" dataField="Id" caption="Rule ID" dataType="number" [allowGrouping]="false" [allowFiltering]="false" [visible]="false" ></dxi-column>
  <dxi-column width="15%" dataField="Name" caption="Name" dataType="string" [allowGrouping]="false" ></dxi-column>
  <dxi-column width="15%" dataField="Description" caption="Description" dataType="string" [allowGrouping]="false" [visible]="false" ></dxi-column>
  <dxi-column width="10%" dataField="StakeholderId" caption="Stakeholder" dataType="string" [allowGrouping]="false" >
    <dxo-lookup
      [dataSource]="stakeholders"
      valueExpr="StakeholdersId"
      displayExpr="Name">
    </dxo-lookup>
  </dxi-column>
  <dxi-column width="30%" dataField="ConditionSummary" caption="Condition" dataType="string" [allowGrouping]="false" ></dxi-column>
  <dxi-column width="30%" dataField="ActionSummary" caption="Action" dataType="string" [allowGrouping]="false" ></dxi-column>
  <dxi-column width="150" dataField="Hits" caption="Runs last 30 days" dataType="number" [allowGrouping]="false"></dxi-column>
  <dxi-column width="180" dataField="LastRun" caption="Last run" [allowGrouping]="false" [allowFiltering]="false" [visible]="false" biz-grid-date format="dateTime"></dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(errorRules(), 'CreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(errorRules(), 'UpdatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

  @if (allowUpdating || allowDeleting) {
    <dxi-column type="buttons" [fixed]="true" fixedPosition="right">
      <dxi-button name="edit" text="Edit" [onClick]="editErrorRule"></dxi-button>
      <dxi-button name="delete" [onClick]="deleteErrorRule" [visible]="isDeleteVisible"></dxi-button>
    </dxi-column>
  }

</dx-data-grid>
